import { FIELD_REQUIRED_MESSAGE } from '../constants/ValidationMessagesConstants';

export const mandatoryFieldValidator = (value: any) => {
    if (!value || value.toString().trim() === '') {
        return FIELD_REQUIRED_MESSAGE;
    }
};
